"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2768],{

/***/ 73957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82307);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var simplebar_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14863);
/* harmony import */ var simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(202);
/* harmony import */ var simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(simplebar_react_dist_simplebar_min_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var _ButtonNormal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77911);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);












var PopupV1 = function PopupV1(_ref) {
  var _popupData$images, _popupData$images$lis, _popupData$images$lis2, _popupData$images2, _popupData$images2$li, _popupData$images2$li2, _popupData$data, _popupData$data2, _popupData$data3, _popupData$data4, _popupData$data5, _popupData$data6, _popupData$data7, _popupData$data8, _popupData$data9, _popupData$data10, _popupData$data11;

  var show = _ref.show,
      handleClose = _ref.handleClose,
      no_img = _ref.no_img,
      item = _ref.item,
      title = _ref.title,
      description = _ref.description,
      data = _ref.data,
      subtitle = _ref.subtitle,
      img = _ref.img,
      winWidth = _ref.winWidth;
  var popupData = data; // const [winWidth, setWinWidth] = useState(true)
  // useEffect(() => {
  //     if (window.innerWidth > 767) {
  //         setWinWidth(true)
  //     } else {
  //         setWinWidth(false)
  //     }
  //     window.addEventListener("resize", () => {
  //         if (window.innerWidth > 767) {
  //             setWinWidth(true)
  //         } else {
  //             setWinWidth(false)
  //         }
  //     });
  // }, [])

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledModal, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      show: show,
      item: item,
      onHide: handleClose,
      backdrop: "static",
      keyboard: false,
      className: "gph_modal popup-version-one",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(simplebar_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "main_scroll",
        style: {
          height: '100vh'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Body */ .Z.Body, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              className: 'for-close',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                onClick: handleClose,
                className: "modal-close ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("svg", {
                  id: "Button_-_Close",
                  "data-name": "Button - Close",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "44",
                  height: "44",
                  viewBox: "0 0 44 44",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                    id: "Ellipse_18",
                    "data-name": "Ellipse 18",
                    fill: "none",
                    stroke: "#3c3c3b",
                    strokeWidth: "1",
                    opacity: "0.3",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                    id: "Ellipse_19",
                    "data-name": "Ellipse 19",
                    fill: "none",
                    stroke: "#3c3c3b",
                    strokeWidth: "1",
                    strokeDasharray: "0 142",
                    opacity: '0',
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "22",
                      stroke: "none"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("circle", {
                      cx: "22",
                      cy: "22",
                      r: "21.5",
                      fill: "none"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                    id: "Group_18979",
                    "data-name": "Group 18979",
                    transform: "translate(-3149 -104.5)",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("line", {
                      id: "Line_4",
                      "data-name": "Line 4",
                      x2: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      strokeWidth: "1"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("line", {
                      id: "Line_3877",
                      "data-name": "Line 3877",
                      x1: "8",
                      y2: "8",
                      transform: "translate(3167 122.5)",
                      fill: "none",
                      stroke: "#3c3c3b",
                      strokeLinecap: "round",
                      strokeWidth: "1"
                    })]
                  })]
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "modal-data d-flex",
                children: [(popupData === null || popupData === void 0 ? void 0 : (_popupData$images = popupData.images) === null || _popupData$images === void 0 ? void 0 : (_popupData$images$lis = _popupData$images.list) === null || _popupData$images$lis === void 0 ? void 0 : (_popupData$images$lis2 = _popupData$images$lis[0]) === null || _popupData$images$lis2 === void 0 ? void 0 : _popupData$images$lis2.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  sm: 4,
                  className: "modal-data__img",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                    alt: 'Shanta Securities Limited',
                    src: popupData === null || popupData === void 0 ? void 0 : (_popupData$images2 = popupData.images) === null || _popupData$images2 === void 0 ? void 0 : (_popupData$images2$li = _popupData$images2.list) === null || _popupData$images2$li === void 0 ? void 0 : (_popupData$images2$li2 = _popupData$images2$li[0]) === null || _popupData$images2$li2 === void 0 ? void 0 : _popupData$images2$li2.full_path
                  }), (popupData === null || popupData === void 0 ? void 0 : (_popupData$data = popupData.data) === null || _popupData$data === void 0 ? void 0 : _popupData$data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
                    children: popupData === null || popupData === void 0 ? void 0 : (_popupData$data2 = popupData.data) === null || _popupData$data2 === void 0 ? void 0 : _popupData$data2.title
                  }), (popupData === null || popupData === void 0 ? void 0 : (_popupData$data3 = popupData.data) === null || _popupData$data3 === void 0 ? void 0 : _popupData$data3.link) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(popupData === null || popupData === void 0 ? void 0 : (_popupData$data4 = popupData.data) === null || _popupData$data4 === void 0 ? void 0 : _popupData$data4.link)
                  }), (popupData === null || popupData === void 0 ? void 0 : (_popupData$data5 = popupData.data) === null || _popupData$data5 === void 0 ? void 0 : _popupData$data5.linkedin) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_ButtonNormal__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    icon: true,
                    margin: '30px 0 0 ',
                    hoverColor: '#000',
                    newtablink: popupData !== null && popupData !== void 0 && (_popupData$data6 = popupData.data) !== null && _popupData$data6 !== void 0 && _popupData$data6.linkedin ? popupData === null || popupData === void 0 ? void 0 : (_popupData$data7 = popupData.data) === null || _popupData$data7 === void 0 ? void 0 : _popupData$data7.linkedin : '#',
                    width: '200',
                    hoverBackground: '#000',
                    background: 'transparent',
                    color: '#000',
                    text: 'Linkedin'
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  sm: {
                    span: 7,
                    offset: 1
                  },
                  className: "modal-data__content",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                    className: "scroll-div",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                      md: 12,
                      children: winWidth > 767 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(simplebar_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        autoHide: true,
                        style: {
                          maxHeight: 'calc(100vh - 100px)'
                        },
                        children: (popupData === null || popupData === void 0 ? void 0 : (_popupData$data8 = popupData.data) === null || _popupData$data8 === void 0 ? void 0 : _popupData$data8.body) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(popupData === null || popupData === void 0 ? void 0 : (_popupData$data9 = popupData.data) === null || _popupData$data9 === void 0 ? void 0 : _popupData$data9.body)
                      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
                        children: (popupData === null || popupData === void 0 ? void 0 : (_popupData$data10 = popupData.data) === null || _popupData$data10 === void 0 ? void 0 : _popupData$data10.body) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(popupData === null || popupData === void 0 ? void 0 : (_popupData$data11 = popupData.data) === null || _popupData$data11 === void 0 ? void 0 : _popupData$data11.body)
                      })
                    })
                  })
                })]
              })
            })
          })]
        })
      })
    })
  });
};

var StyledModal = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PopupV1__StyledModal",
  componentId: "sc-1e63m28-0"
})([".modal-dialog{margin:0;}h4{letter-spacing:1.5px;}"]);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(PopupV1));

/***/ }),

/***/ 8711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98508);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var InnerbannerV9 = function InnerbannerV9(_ref) {
  var full = _ref.full,
      title = _ref.title,
      text = _ref.text,
      project = _ref.project,
      id = _ref.id,
      src = _ref.src,
      vh = _ref.vh,
      data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledInnerBanner, {
    id: "".concat(id ? id : 'InnerBanner'),
    full: full,
    vh: vh,
    className: "InnerBanner ".concat(project ? 'project_banner' : ''),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "InnerBanner__parallax",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "blur_image parallax",
        children: [src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_0__/* .Img */ .E, {
          src: src,
          alt: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
              className: "flex_box ",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 7,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "title",
                  children: title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(title)
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                md: 5,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                  className: "text",
                  children: text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                    "data-lag": '0.4',
                    children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(text)
                  })
                })
              })]
            })
          })
        })]
      })
    })
  });
};

var StyledInnerBanner = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "innerbanner-v9__StyledInnerBanner",
  componentId: "sc-1lkjrda-0"
})(["position:relative;.InnerBanner__parallax{padding-top:", ";position:relative;@media (min-width:1550px){padding-top:", ";}@media (max-width:767px){padding-top:", ";}.flex_box{display:flex;justify-content:space-between;align-items:flex-end;width:100%;@media (max-width:767px){flex-direction:column;text-align:left;align-items:flex-start;}.text{position:relative;z-index:2;display:flex;justify-content:flex-end;@media (max-width:767px){display:block;justify-content:unset;}p{font-size:16px;font-weight:500;line-height:24px;color:#FFFFFF;@media (max-width:767px){text-align:left;br{}}}}}.blur_image{width:100%;height:100%;position:absolute;left:0;right:0;bottom:0;}.container{position:absolute;margin:0 auto;z-index:2;bottom:100px;left:0;right:0;@media (max-width:767px){bottom:40px;}h1{z-index:2;font-size:44px;line-height:56px;letter-spacing:-1px;margin:30px 0 0;font-weight:500;color:#FFFFFF;font-family:'Avenir';@media (max-width:767px){font-size:36px;line-height:42px;margin-bottom:15px;}}}}@media (min-width:1550px){}@media (max-width:767px){.InnerBanner__parallax{padding-top:", ";.container{bottom:40px;h1{font-size:40px;line-height:40px;margin:0px 0 20px;}}.flex_box{flex-direction:column;text-align:left;align-items:flex-start;.title{width:100%;}.text{display:block;justify-content:unset;p{width:100%;text-align:left;br{}}}}}}"], function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 1366 * 100%)';
}, function (props) {
  return props.full ? '100vh' : 'calc(560 / 375 * 100%)';
}, function (props) {
  return props.full ? '100vh' : '70vh';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(InnerbannerV9));

/***/ }),

/***/ 74836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResearchList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(21608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./components/Img.jsx
var Img = __webpack_require__(68019);
// EXTERNAL MODULE: ./styles/globalStyleVars.js
var globalStyleVars = __webpack_require__(68312);
// EXTERNAL MODULE: ./components/Title.jsx
var Title = __webpack_require__(93264);
// EXTERNAL MODULE: ./components/Button.jsx
var Button = __webpack_require__(36981);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 51 modules
var react_select_esm = __webpack_require__(87118);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/gsap/index.js
var gsap = __webpack_require__(62642);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(56546);
// EXTERNAL MODULE: ./components/PopupV1.jsx
var PopupV1 = __webpack_require__(73957);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/research-expert/ExpertList.jsx

















var RandomSliderV1 = function RandomSliderV1(_ref) {
  var offset = _ref.offset,
      data = _ref.data;
  var DropdownOption = [{
    value: 'Economy',
    label: 'Economy'
  }, {
    value: 'Blog',
    label: 'Blog'
  }, {
    value: 'Market Review',
    label: 'Market Review'
  }, {
    value: 'Strategy Report',
    label: 'Strategy Report'
  }, {
    value: 'Company Review',
    label: 'Company Review'
  }, {
    value: 'Research Experts',
    label: 'Research Experts'
  }, {
    value: 'Economic Dashboard',
    label: 'Economic Dashboard'
  }, {
    value: 'Company Dashboard',
    label: 'Company Dashboard'
  }];

  var handleResearch = function handleResearch(e) {// setReg({...reg, department: e})
  };

  var _useState = (0,react.useState)(false),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = (0,react.useState)(),
      popupId = _useState2[0],
      setPopupId = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow(e) {
    setShow(true);
    setPopupId(e);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBlog, {
    offset: offset,
    className: "",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PopupV1/* default */.Z, {
      show: show,
      data: popupId,
      handleClose: handleClose
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "blog-slider__slider-wrap__inner row",
      children: data && (data === null || data === void 0 ? void 0 : data.length) > 0 && (data === null || data === void 0 ? void 0 : data.map(function (e, index) {
        var _e$images, _e$images$list, _e$images$list$, _e$images2, _e$images2$list, _e$images2$list$, _e$data, _e$data2, _e$data3, _e$data4;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          md: 4,
          className: 'single-expert',
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              return handleShow(e);
            },
            className: "single-expert-item",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "img-wrp",
              children: (e === null || e === void 0 ? void 0 : (_e$images = e.images) === null || _e$images === void 0 ? void 0 : (_e$images$list = _e$images.list) === null || _e$images$list === void 0 ? void 0 : (_e$images$list$ = _e$images$list[0]) === null || _e$images$list$ === void 0 ? void 0 : _e$images$list$.full_path) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                alt: 'Shanta Securities Limited',
                src: e === null || e === void 0 ? void 0 : (_e$images2 = e.images) === null || _e$images2 === void 0 ? void 0 : (_e$images2$list = _e$images2.list) === null || _e$images2$list === void 0 ? void 0 : (_e$images2$list$ = _e$images2$list[0]) === null || _e$images2$list$ === void 0 ? void 0 : _e$images2$list$.full_path
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "content",
              children: [(e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                children: e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.title
              }), (e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.link) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.link)
              })]
            })]
          })
        });
      }))
    })]
  });
};

var StyledBlog = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ExpertList__StyledBlog",
  componentId: "sc-1qm50td-0"
})([".mobile{display:none;}.single-expert{margin-bottom:80px;.single-expert-item{cursor:pointer;.img-wrp{padding-top:calc(370 / 370 * 100%);position:relative;overflow:hidden;.global-image{transition:1s all cubic-bezier(.25,.74,.22,.99);overflow:hidden;transform:scale(1.01);}img{position:absolute;inset:0;height:100%;width:100%;object-fit:cover;transition:1s all cubic-bezier(.25,.74,.22,.99);overflow:hidden;transform:scale(1.01);}}.content{margin-top:20px;h5{font-size:20px;font-weight:500;line-height:28px;color:#3C3C3B;margin-bottom:0;}p{font-size:16px;font-weight:500;line-height:28px;color:rgba(60,60,59,0.5);}}&:hover{.global-images{transform:scale(1.06);}img{transform:scale(1.06);}}}@media(max-width:767px){margin-bottom:30px;&:last-child{margin-bottom:0;}}}.blog-title{position:relative;p{position:absolute;top:0;right:0;}}.load{.dc-btn{display:flex;align-items:center;justify-content:center;margin-top:50px;}}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single__inner{padding-top:calc(460 / 370 * 100%);position:relative;a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{&:after{content:'';height:100%;width:100%;background-color:#3C3C3B;top:0;left:0;right:0;position:absolute;transition:height 1s cubic-bezier(.25,.74,.22,.99);}&__top{.hover-content{position:absolute;left:40px;top:40px;right:40px;transition:all 1s cubic-bezier(.25,.74,.22,.99);transform:translateY(-30px);opacity:0;.link-dc{font-size:16px;line-height:24px;color:#FFFFFF;font-family:'Avenir Heavy';width:auto !important;height:auto !important;position:relative !important;margin-top:5px;opacity:0;display:inline-block;&:before{background:#fff;transition:all 1s cubic-bezier(.25,.74,.22,.99) 0s;content:\"\";position:absolute;left:0px;bottom:0px;height:1px;width:100%;}&:hover{&:before{height:4px;}}}p{font-size:16px;font-weight:500;line-height:24px;color:#ffffff;z-index:2;margin:0;opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:20px;font-weight:500;font-family:", ";line-height:28px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;padding-top:20px;z-index:2;h4{font-size:60px;color:#FFFFFF;font-family:'Avenir Book';line-height:60px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:16px;color:#FFFFFF;text-align:right;font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:#FFFFFF;}}}}&:hover{.blog-single__inner__content:after{height:0;}.blog-single__inner__content__top{h2{opacity:0;transform:translateY(-20px);}.link-dc{transform:none;opacity:1;&:before{}}.hover-content{transform:none;opacity:1;}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}.css-lkh0o5-menu{z-index:9;margin:0;}@media (max-width:767px){.mobile{display:block;}.desktop{display:none !important;}padding-top:0;.filter{padding:0;.react-select__control{border:none !important;height:60px;background:#978c21;box-shadow:none !important;.react-select__control--menu-is-open{box-shadow:none !important;.react-select__indicator{padding-right:15px;}}.react-select__value-container{padding:0px 15px;}.react-select__indicator{padding:15px;svg{path{fill:white;stroke-width:0;}}}.react-select__indicator-separator{display:none;}.react-select__single-value{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}.select__single-value,.react-select__placeholder{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}.react-select__input-container{.react-select__input{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}}}}.blog-single__inner__content__top{p,h2{left:30px;right:30px;top:30px;}}.blog-single__inner__content__bottom h4,.blog-single__inner__content__bottom p{left:30px;right:30px;top:30px;}.swiper-initialized{margin-left:0;padding-right:0;}.blog-slider{&__slider-wrap{.slider-nav-mobile{margin-top:40px;ul{display:flex;}li{height:50px;width:50px;background-color:#000;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}}.blog-button{margin-bottom:40px;.slider-nav{display:none;}}.slider-nav-mobile{display:block;}}"], Title["default"]);
/* harmony default export */ var ExpertList = (RandomSliderV1);
// EXTERNAL MODULE: ./components/ButtonLoadMore.jsx
var ButtonLoadMore = __webpack_require__(18987);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/rsuite/esm/DateRangePicker/index.js + 293 modules
var DateRangePicker = __webpack_require__(284);
// EXTERNAL MODULE: ./node_modules/rsuite/dist/rsuite.css
var rsuite = __webpack_require__(7411);
// EXTERNAL MODULE: ./pages/api/network/ApiServices.js
var ApiServices = __webpack_require__(92495);
// EXTERNAL MODULE: ./pages/api/redux/research/index.js
var research = __webpack_require__(83473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./pages/api/network/ApiParamKey.js
var ApiParamKey = __webpack_require__(11267);
// EXTERNAL MODULE: ./pages/api/store/index.js + 9 modules
var store = __webpack_require__(38584);
;// CONCATENATED MODULE: ./components/research/ResearchList.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }































var ResearchList_RandomSliderV1 = function RandomSliderV1(_ref) {
  var _researchCategories$r, _data$blog, _data$blog2, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _filter10;

  var offset = _ref.offset,
      data = _ref.data,
      filter = _ref.filter;
  gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger.ScrollTrigger);

  var _useState = (0,react.useState)('report'),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useState2 = (0,react.useState)(false),
      activeTabFilter = _useState2[0],
      setActiveTabFilter = _useState2[1];

  var _useState3 = (0,react.useState)('economy'),
      activeTabReports = _useState3[0],
      setActiveReports = _useState3[1];

  var _useState4 = (0,react.useState)('economic_dashboard'),
      activeTabDashboard = _useState4[0],
      setActiveDashboard = _useState4[1];

  var _useState5 = (0,react.useState)(),
      height = _useState5[0],
      setHeight = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      filterD = _useState6[0],
      setFilterD = _useState6[1];

  var _useState7 = (0,react.useState)(),
      filterTopic = _useState7[0],
      setFilterTopic = _useState7[1];

  var dateRangePickerRef = (0,react.useRef)(null);

  var _useState8 = (0,react.useState)(6),
      visibleItems = _useState8[0],
      setVisibleItems = _useState8[1]; // Number of items initially visible


  var itemsPerPage = 6; // Number of items to load per click

  var _useState9 = (0,react.useState)(false),
      comming = _useState9[0],
      setComming = _useState9[1];

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState10 = (0,react.useState)(1),
      currentReport = _useState10[0],
      setCurrentReport = _useState10[1];

  var _useState11 = (0,react.useState)(''),
      selectedFilter = _useState11[0],
      setSelectedFilter = _useState11[1];

  var _useState12 = (0,react.useState)(''),
      showData = _useState12[0],
      setShowData = _useState12[1];

  var selectInputRefSelect = (0,react.useRef)();
  var selectInputRefSelectMobile = (0,react.useRef)();

  var _useState13 = (0,react.useState)(null),
      dateRange = _useState13[0],
      setDateRange = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      isMenuOpen = _useState14[0],
      setIsMenuOpen = _useState14[1];

  var _useState15 = (0,react.useState)(null),
      selectedOptionMobile = _useState15[0],
      setSelectedOptionMobile = _useState15[1];

  var _useState16 = (0,react.useState)(null),
      selectedOptionMobilePlaceholder = _useState16[0],
      setSelectedOptionMobilePlaceholder = _useState16[1];

  var _useState17 = (0,react.useState)(null),
      selectMobileValue = _useState17[0],
      setSelectMobileValue = _useState17[1];

  var _useState18 = (0,react.useState)(null),
      selectBlogValue = _useState18[0],
      setSelectBlogValue = _useState18[1];

  var _useState19 = (0,react.useState)('Select Reports'),
      selectMobilePlaceHolder = _useState19[0],
      setSelectMobilePlaceHolder = _useState19[1];

  var selectInputRefSelectReport = (0,react.useRef)(); // on page load go down

  var router = (0,next_router.useRouter)();

  var handleResearch = function handleResearch(e, id, label) {
    var _selectInputRefSelect;

    setVisibleItems(6);
    setActiveTab(e);
    setSelectedOptionMobile(e);
    setSelectedOptionMobilePlaceholder(label);
    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect = selectInputRefSelect.current) === null || _selectInputRefSelect === void 0 ? void 0 : _selectInputRefSelect.clearValue();

    if (id) {
      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, id);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    if (e === 'report') {
      handleReport('economy', 1, 'Economy');
    }

    if (e === 'ipo_notes_listing') {
      handleClickReports('ipo_notes_listing', 7);
    }

    if (e === 'fixed_income') {
      handleClickReports('fixed_income', 8);
    }

    if (e === 'flash_note_listing') {
      handleClickReports('flash_note_listing', 9);
    }

    window.location.hash = "".concat(e);
  };

  var handleClick = function handleClick(tab, id) {
    var _selectInputRefSelect2, _selectInputRefSelect3, _selectInputRefSelect4;

    // Add a flag to track whether an API call has been made
    var apiCalled = false;
    setVisibleItems(6);

    if (id && !apiCalled) {
      apiCalled = true; // Set the flag to true to indicate API call initiation

      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, id);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    setActiveTab(tab); // Assuming you have a function to handle tab activation

    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect2 = selectInputRefSelect.current) === null || _selectInputRefSelect2 === void 0 ? void 0 : _selectInputRefSelect2.clearValue(); // Update the URL hash to reflect the selected tab

    window.location.hash = "".concat(tab);

    if (tab === 'report') {
      handleClickReports('economy', 1);
    }

    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect3 = selectInputRefSelect.current) === null || _selectInputRefSelect3 === void 0 ? void 0 : _selectInputRefSelect3.clearValue();
    selectInputRefSelectReport === null || selectInputRefSelectReport === void 0 ? void 0 : (_selectInputRefSelect4 = selectInputRefSelectReport.current) === null || _selectInputRefSelect4 === void 0 ? void 0 : _selectInputRefSelect4.clearValue();
    setSelectMobilePlaceHolder('Select Reports'); // setTimeout(() => {
    //     ScrollTrigger.refresh();
    //
    // }, 300);
  };

  var handleClickInitial = function handleClickInitial(tab, id) {
    var _selectInputRefSelect5;

    // Add a flag to track whether an API call has been made
    var apiCalled = false;
    setVisibleItems(6);

    if (id && !apiCalled) {
      apiCalled = true; // Set the flag to true to indicate API call initiation

      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, id);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    setActiveTab(tab); // Assuming you have a function to handle tab activation
    // Update the URL hash to reflect the selected tab

    if (tab === 'report') {
      handleClickReports('economy', 1);
    }

    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect5 = selectInputRefSelect.current) === null || _selectInputRefSelect5 === void 0 ? void 0 : _selectInputRefSelect5.clearValue(); // setTimeout(() => {
    //     ScrollTrigger.refresh();
    //
    // }, 300);
  };

  var handleClickNews = function handleClickNews(tab, id) {
    var _selectInputRefSelect6;

    // Add a flag to track whether an API call has been made
    var apiCalled = false;
    setVisibleItems(6);

    if (id && !apiCalled) {
      apiCalled = true; // Set the flag to true to indicate API call initiation

      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, id);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect6 = selectInputRefSelect.current) === null || _selectInputRefSelect6 === void 0 ? void 0 : _selectInputRefSelect6.clearValue();
    setActiveTab(tab); // Assuming you have a function to handle tab activation
    // Update the URL hash to reflect the selected tab

    window.location.hash = "".concat(tab); // setTimeout(() => {
    //     ScrollTrigger.refresh();
    //
    // }, 300);
  };

  var handleClickNewsInitial = function handleClickNewsInitial(tab, id) {
    var _selectInputRefSelect7;

    // Add a flag to track whether an API call has been made
    var apiCalled = false;
    setVisibleItems(6);

    if (id && !apiCalled) {
      apiCalled = true; // Set the flag to true to indicate API call initiation

      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, id);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect7 = selectInputRefSelect.current) === null || _selectInputRefSelect7 === void 0 ? void 0 : _selectInputRefSelect7.clearValue();
    setActiveTab(tab); // Assuming you have a function to handle tab activation
    // Update the URL hash to reflect the selected tab

    window.location.hash = "".concat(tab); // setTimeout(() => {
    //     ScrollTrigger.refresh();
    //
    // }, 300);
  };

  var handleClickReports = function handleClickReports(tab, id) {
    var _selectInputRefSelect8;

    setVisibleItems(6);
    setActiveTabFilter(id);
    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect8 = selectInputRefSelect.current) === null || _selectInputRefSelect8 === void 0 ? void 0 : _selectInputRefSelect8.clearValue();

    if (id) {
      var _param6;

      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;
      var param = (_param6 = {}, (0,defineProperty/* default */.Z)(_param6, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, id), (0,defineProperty/* default */.Z)(_param6, ApiParamKey/* ApiParamKey.TIME */.j.TIME, Date.now()), _param6);
      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    setCurrentReport(id);
    setActiveReports(tab);
    setComming(false);

    if (dateRangePickerRef.current) {
      var _dateRangePickerRef$c;

      dateRangePickerRef === null || dateRangePickerRef === void 0 ? void 0 : (_dateRangePickerRef$c = dateRangePickerRef.current) === null || _dateRangePickerRef$c === void 0 ? void 0 : _dateRangePickerRef$c.close(true);
    }

    setFilterD(false);

    if (id === 1) {
      // Update the filterCustom array with new values
      var updatedFilterCustom = [{
        value: '1',
        label: 'Fiscal Policy'
      }, {
        value: '2',
        label: 'Money Market Update'
      }, {
        value: '3',
        label: 'Macro-Regular update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(updatedFilterCustom);
      setSelectedFilter(null);
    }

    if (id === 2) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom = [{
        value: '4',
        label: 'Daily Market Update'
      }, {
        value: '5',
        label: 'Weekly Market Update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom);
      setSelectedFilter(null);
    }

    if (id === 3) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom2 = [{
        value: '6',
        label: 'FMCG'
      }, {
        value: '7',
        label: 'Pharma'
      }, {
        value: '8',
        label: 'Financials'
      }, {
        value: '9',
        label: 'Telecom'
      }, {
        value: '10',
        label: 'Market and Others'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom2);
      setSelectedFilter(null);
    }

    if (id === 4) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom3 = [{
        value: '11',
        label: 'Initiation Coverage'
      }, {
        value: '12',
        label: 'Valuation Update'
      }, {
        value: '13',
        label: 'Flash Notes and Earnings Update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom3);
      setSelectedFilter(null);
    }

    if (id === 8) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom4 = [{
        value: '14',
        label: 'Government Securities'
      }, {
        value: '15',
        label: 'Corporate Bonds'
      }, {
        value: '16',
        label: 'Upcoming Auction'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom4);
      setSelectedFilter(null);
    } //
    // setTimeout(() => {
    //     ScrollTrigger.refresh();
    // }, 900);

  };

  var handleClickDashboard = function handleClickDashboard(tab) {
    setVisibleItems(6);
    setActiveDashboard(tab); // setTimeout(() => {
    //     ScrollTrigger.refresh();
    // }, 300);
  };

  var handleReport = function handleReport(e, id, label) {
    var _selectInputRefSelect9;

    if (id) {
      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT + '?type=' + id;
      dispatch((0,research/* fetchResearch */.FG)([api_url_search]));
    }

    setSelectMobileValue(e);

    if (e === 'economy') {
      setSelectMobilePlaceHolder('Economy');
    }

    if (e === 'market') {
      setSelectMobilePlaceHolder('Market Review');
    }

    if (e === 'company') {
      setSelectMobilePlaceHolder('Company Updates');
    }

    if (e === 'sector') {
      setSelectMobilePlaceHolder('Strategy Report');
    }

    if (e === 'ipo_notes') {
      setSelectMobilePlaceHolder('IPO/QIO Notes');
    }

    if (e === 'fixed_income') {
      setSelectMobilePlaceHolder('Fixed Income Notes');
    }

    if (e === 'flash_notes') {
      setSelectMobilePlaceHolder('Flash Notes');
    }

    setDateRange(null);
    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect9 = selectInputRefSelect.current) === null || _selectInputRefSelect9 === void 0 ? void 0 : _selectInputRefSelect9.clearValue();
    setCurrentReport(id);
    setActiveReports(e);
    setFilterD(true);
    var cleanButton = document.querySelector('.rs-picker-toggle-clean');
    cleanButton && cleanButton.click();
    setComming(false);
    setFilterD(false);

    if (id === 1) {
      // Update the filterCustom array with new values
      var updatedFilterCustom = [{
        value: '1',
        label: 'Fiscal Policy'
      }, {
        value: '2',
        label: 'Money Market Update'
      }, {
        value: '3',
        label: 'Macro-Regular update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(updatedFilterCustom);
      setSelectedFilter(null);
    }

    if (id === 2) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom5 = [{
        value: '4',
        label: 'Daily Market Update'
      }, {
        value: '5',
        label: 'Weekly Market Update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom5);
      setSelectedFilter(null);
    }

    if (id === 3) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom6 = [{
        value: '6',
        label: 'FMCG'
      }, {
        value: '7',
        label: 'Pharma'
      }, {
        value: '8',
        label: 'Financials'
      }, {
        value: '9',
        label: 'Telecom'
      }, {
        value: '10',
        label: 'Market and Others'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom6);
      setSelectedFilter(null);
    }

    if (id === 4) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom7 = [{
        value: '11',
        label: 'Initiation Coverage'
      }, {
        value: '12',
        label: 'Valuation Update'
      }, {
        value: '13',
        label: 'Flash Notes and Earnings Update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom7);
      setSelectedFilter(null);
    }

    if (id === 8) {
      // Update the filterCustom array with new values
      var _updatedFilterCustom8 = [{
        value: '14',
        label: 'Government Securities'
      }, {
        value: '15',
        label: 'Corporate Bonds'
      }, {
        value: '16',
        label: 'Upcoming Auction'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom8);
      setSelectedFilter(null);
    }
  };

  var handleDashboard = function handleDashboard(e) {
    var _selectInputRefSelect10;

    if (e !== null && e !== void 0 && e.id) {
      var api_url_search = ApiServices/* ApiServices.REARCHLISTCA */.u.REARCHLISTCA;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, e === null || e === void 0 ? void 0 : e.id);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    selectInputRefSelect === null || selectInputRefSelect === void 0 ? void 0 : (_selectInputRefSelect10 = selectInputRefSelect.current) === null || _selectInputRefSelect10 === void 0 ? void 0 : _selectInputRefSelect10.clearValue();
    setActiveDashboard(e); // setTimeout(() => {
    //     ScrollTrigger.refresh();
    // }, 300);
  };

  var DropdownOption = [{
    value: 'report',
    label: 'Reports'
  }, {
    value: 'dashboard',
    label: 'Dashboard'
  }, {
    value: 'news_flash',
    label: 'News Flash',
    id: 6
  }, {
    value: 'blog',
    label: 'Blog'
  }, {
    value: 'expert',
    label: 'Research Experts'
  }];
  var DropdownOptionReports = [{
    value: 'economy',
    label: 'Economy',
    id: 1
  }, {
    value: 'market',
    label: 'Market Review',
    id: 2
  }, {
    value: 'company',
    label: 'Company Updates',
    id: 4
  }, {
    value: 'sector',
    label: 'Strategy Report',
    id: 3
  }, {
    value: 'ipo_notes',
    label: 'IPO/QIO Notes',
    id: 7
  }, {
    value: 'fixed_income',
    label: 'Fixed Income Notes',
    id: 8
  }, {
    value: 'flash_notes',
    label: 'Flash Notes',
    id: 9
  }];
  var DropdownOptionDasboard = [{
    value: 'economic_dashboard',
    label: 'Economy Dashboard'
  }, {
    value: 'company_dashboard',
    label: 'Company Dashboard'
  }, {
    value: 'interest_rate',
    label: 'Interest Rate'
  }];

  var _useState20 = (0,react.useState)([{
    value: '1',
    label: 'Fiscal Policy'
  }, {
    value: '2',
    label: 'Money Market Update'
  }, {
    value: '3',
    label: 'Macro-Regular update'
  }]),
      filterCustom = _useState20[0],
      setFilterCustom = _useState20[1];

  var _useState21 = (0,react.useState)('1'),
      state = _useState21[0],
      setState = _useState21[1]; // date wise filter


  var formatDate = function formatDate(date) {
    // Helper function to format the date as yyyy-mm-dd.
    return date.toISOString().slice(0, 10);
  };

  var handleSelect = function handleSelect(dates) {
    var _param8;

    var start = formatDate(dates === null || dates === void 0 ? void 0 : dates[0]);
    var end = formatDate(dates === null || dates === void 0 ? void 0 : dates[1]);
    var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;
    var param = (_param8 = {}, (0,defineProperty/* default */.Z)(_param8, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, currentReport), (0,defineProperty/* default */.Z)(_param8, ApiParamKey/* ApiParamKey.FILTER */.j.FILTER, filterTopic), (0,defineProperty/* default */.Z)(_param8, ApiParamKey/* ApiParamKey.STARTDATE */.j.STARTDATE, start), (0,defineProperty/* default */.Z)(_param8, ApiParamKey/* ApiParamKey.ENDDATE */.j.ENDDATE, end), _param8);
    dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    setFilterD(true);
    setDateRange(dates);
  };

  var handleFocus = function handleFocus() {
    // Set body overflow to hidden on focus
    document.body.style.overflow = 'hidden';
    var html = document.querySelector('html');
    html.style.overflow = 'hidden';
  };

  var handleBlur = function handleBlur() {
    // Revert body overflow to its original value on blur
    document.body.style.overflow = 'auto';
    var html = document.querySelector('html');
    html.style.overflow = 'auto';
  };

  var renderDateRangeInput = function renderDateRangeInput(value, placeholder) {
    // Custom render function to set the placeholder for the input field
    return /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "text",
      readOnly: true,
      value: value,
      placeholder: placeholder
    });
  };

  var handleFilter = function handleFilter(e, report) {
    setSelectedFilter(e === null || e === void 0 ? void 0 : e.label);
    setDateRange(null); // document?.querySelector('.no_data').classList?.remove('active')

    var data = null;

    if (report === 'economy') {
      data = 1;
    }

    if (report === 'market') {
      data = 2;
    }

    if (report === 'sector') {
      data = 3;
    }

    if (report === 'company') {
      data = 4;
    }

    if (report === 'fixed_income') {
      data = 8;
    }

    if (e && report) {
      var _param9;

      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;
      var param = (_param9 = {}, (0,defineProperty/* default */.Z)(_param9, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, data), (0,defineProperty/* default */.Z)(_param9, ApiParamKey/* ApiParamKey.FILTER */.j.FILTER, e === null || e === void 0 ? void 0 : e.value), (0,defineProperty/* default */.Z)(_param9, ApiParamKey/* ApiParamKey.TIME */.j.TIME, Date.now()), _param9);
      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }

    setFilterTopic(e === null || e === void 0 ? void 0 : e.value);
    setCurrentReport(data); // setActiveReports(data);

    if (dateRangePickerRef.current) {
      var _dateRangePickerRef$c2;

      dateRangePickerRef === null || dateRangePickerRef === void 0 ? void 0 : (_dateRangePickerRef$c2 = dateRangePickerRef.current) === null || _dateRangePickerRef$c2 === void 0 ? void 0 : _dateRangePickerRef$c2.close(true);
    }

    if (activeTabReports === 'economy') {
      // Update the filterCustom array with new values
      var updatedFilterCustom = [{
        value: '1',
        label: 'Fiscal Policy'
      }, {
        value: '2',
        label: 'Money Market Update'
      }, {
        value: '3',
        label: 'Macro-Regular update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(updatedFilterCustom);
      setSelectedFilter(null); // Clear the selected value
    }

    if (activeTabReports === 'market') {
      // Update the filterCustom array with new values
      var _updatedFilterCustom9 = [{
        value: '4',
        label: 'Daily Market Update'
      }, {
        value: '5',
        label: 'Weekly Market Update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom9);
      setSelectedFilter(null); // Clear the selected value
    }

    if (activeTabReports === 'sector') {
      // Update the filterCustom array with new values
      var _updatedFilterCustom10 = [{
        value: '6',
        label: 'FMCG'
      }, {
        value: '7',
        label: 'Pharma'
      }, {
        value: '8',
        label: 'Financials'
      }, {
        value: '9',
        label: 'Telecom'
      }, {
        value: '10',
        label: 'Market and Others'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom10);
      setSelectedFilter(null); // Clear the selected value
    }

    if (activeTabReports === 'company') {
      // Update the filterCustom array with new values
      var _updatedFilterCustom11 = [{
        value: '11',
        label: 'Initiation Coverage'
      }, {
        value: '12',
        label: 'Valuation Update'
      }, {
        value: '13',
        label: 'Flash Notes and Earnings Update'
      }]; // Update the state with the new filterCustom array

      setFilterCustom(_updatedFilterCustom11);
      setSelectedFilter(null); // Clear the selected value
    }

    setFilterD(true); // setTimeout(() => {
    //     const item2 = document?.querySelector('.no_data');
    //     if (filterD === true &&item2) {
    //
    //         setComming(true)
    //         item2.style.opacity = '1'
    //     }
    //     ScrollTrigger.refresh();
    // }, 900);
  };

  var loadMore = function loadMore() {
    setVisibleItems(function (prevVisibleItems) {
      return prevVisibleItems + itemsPerPage;
    });
  };

  (0,react.useEffect)(function () {
    var _filter;

    if (((_filter = filter) === null || _filter === void 0 ? void 0 : _filter.length) === 0) {
      // Check for an empty array
      setComming(true);
    } else {
      setComming(false);
    }
  }, [filter]);
  (0,react.useEffect)(function () {
    var _document$querySelect;

    var heightblog = (_document$querySelect = document.querySelector('.blog-slider__slider-wrap')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientHeight;
    setHeight(heightblog);
  });
  (0,react.useEffect)(function () {
    var buttonClickClose = document.querySelector('.rs-btn-close');

    if ((buttonClickClose === null || buttonClickClose === void 0 ? void 0 : buttonClickClose.length) > 0) {
      buttonClickClose.addEventListener('click', function (e) {});
    }
  }, [router === null || router === void 0 ? void 0 : router.pathname]);
  (0,react.useEffect)(function () {
    var hash = window.location.hash;

    if (hash) {
      var mainHash = hash.replace('#', '');

      if (mainHash === 'news_flash') {
        handleClickNewsInitial(mainHash, 6);
        handleResearch(mainHash, null, 'News Flash');
      } else {
        handleClickInitial(mainHash);

        if (mainHash === 'report') {
          handleResearch(mainHash, null, 'Reports');
          handleReport('economy', 1);
          setSelectMobileValue(DropdownOptionReports.find(function (option) {
            return option.value === 'economy';
          }));
        }

        if (mainHash === 'dashboard') {
          handleResearch(mainHash, null, 'Dashboard');
        }

        if (mainHash === 'blog') {
          handleResearch(mainHash, null, 'Blog');
        }

        if (mainHash === 'expert') {
          handleResearch(mainHash, null, 'Research Experts');
        }
      }
    } else {
      var api_url_search = ApiServices/* ApiServices.REARCHLISTCAT */.u.REARCHLISTCAT;

      var param = (0,defineProperty/* default */.Z)({}, ApiParamKey/* ApiParamKey.TYPE */.j.TYPE, state);

      dispatch((0,research/* fetchResearch */.FG)([api_url_search, param]));
    }
  }, [router]);
  var researchCategories = (0,es/* useSelector */.v9)(function (state) {
    return state.researchReducer;
  }); // Assuming 'research' is the reducer for the second API call.

  filter = filter ? filter : researchCategories === null || researchCategories === void 0 ? void 0 : (_researchCategories$r = researchCategories.researchFilter) === null || _researchCategories$r === void 0 ? void 0 : _researchCategories$r.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ResearchList_StyledBlog, {
    offset: offset,
    id: 'blog-slider',
    className: "blog-slider  pb-160",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
          md: 12,
          className: 'filter filter_new_design',
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: 'desktop',
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: " ".concat(activeTab === 'report' ? 'active' : ''),
              id: "report",
              onClick: function onClick() {
                return handleClick('report');
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                border: '1px',
                borderColor: 'rgba(60,60,59,0.5)',
                width: '100',
                text: 'Reports',
                color: '#3C3C3B',
                hoverBackground: globalStyleVars/* hover */.Mr,
                background: 'transparent'
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: activeTab === 'dashboard' ? 'active' : '',
              id: "dashboard",
              onClick: function onClick() {
                return handleClick('dashboard');
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                border: '1px',
                borderColor: 'rgba(60,60,59,0.5)',
                width: '100',
                text: 'Dashboard',
                color: '#3C3C3B',
                hoverBackground: globalStyleVars/* hover */.Mr,
                background: 'transparent'
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: activeTab === 'news_flash' ? 'active' : '',
              id: "news_flash",
              onClick: function onClick() {
                return handleClickNews('news_flash', 6);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                border: '1px',
                borderColor: 'rgba(60,60,59,0.5)',
                width: '100',
                text: 'News Flash',
                color: '#3C3C3B',
                hoverBackground: globalStyleVars/* hover */.Mr,
                background: 'transparent'
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: activeTab === 'blog' ? 'active' : '',
              id: "blog",
              onClick: function onClick() {
                return handleClick('blog');
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                border: '1px',
                borderColor: 'rgba(60,60,59,0.5)',
                width: '100',
                text: 'Blog',
                color: '#3C3C3B',
                hoverBackground: globalStyleVars/* hover */.Mr,
                background: 'transparent'
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: activeTab === 'expert' ? 'active' : '',
              id: "expert",
              onClick: function onClick() {
                return handleClick('expert');
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                border: '1px',
                borderColor: 'rgba(60,60,59,0.5)',
                width: '100',
                text: 'Research Experts',
                color: '#3C3C3B',
                hoverBackground: globalStyleVars/* hover */.Mr,
                background: 'transparent'
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mobile",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
              isSearchable: false,
              placeholder: selectedOptionMobilePlaceholder ? selectedOptionMobilePlaceholder : 'Reports',
              onChange: function onChange(e) {
                return handleResearch(e.value, e === null || e === void 0 ? void 0 : e.id, e === null || e === void 0 ? void 0 : e.label);
              },
              styles: {
                dropdownIndicator: function dropdownIndicator(provided, state) {
                  return _objectSpread(_objectSpread({}, provided), {}, {
                    transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                  });
                }
              },
              value: selectedOptionMobile,
              classNamePrefix: 'react-select',
              className: 'form-select',
              options: DropdownOption,
              theme: function theme(_theme) {
                return _objectSpread(_objectSpread({}, _theme), {}, {
                  borderRadius: 0,
                  colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
                    primary25: '#e9e9e9',
                    primary: 'black'
                  })
                });
              }
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "min-height-box",
        children: [filter && filter.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-tab": 'news_flash',
          className: " fade-up blog-slider__slider-wrap ".concat(activeTab === 'news_flash' ? 'active' : ''),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "blog-slider__slider-wrap__inner row",
            children: filter.slice(0, visibleItems).map(function (e, index) {
              var dateString = e === null || e === void 0 ? void 0 : e.date;
              var date = new Date(dateString);
              var options1 = {
                day: 'numeric'
              };
              var options2 = {
                month: 'long',
                year: 'numeric'
              };
              var formattedDate1 = date.toLocaleDateString('en-US', options1);
              var formattedDate2 = date.toLocaleDateString('en-US', options2);
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                md: 4,
                className: 'blog-single-single-wrp',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-single ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "blog-single__inner",
                    children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: e === null || e === void 0 ? void 0 : e.attachment,
                      target: '_blank'
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                      alt: 'Shanta Securities Limited',
                      src: e !== null && e !== void 0 && e.thumb ? e === null || e === void 0 ? void 0 : e.thumb : '/images/static/report.jpg',
                      objectFit: 'cover',
                      layout: 'fill'
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "blog-single__inner__content",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "blog-single__inner__content__top",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "hover-content",
                          children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                          }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            className: 'link-dc',
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank',
                            children: "Read More"
                          })]
                        }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                          children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "blog-single__inner__content__bottom",
                        children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                          children: formattedDate1
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                          children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: "News Flash"
                          })]
                        })]
                      })]
                    })]
                  })
                })
              });
            })
          }), visibleItems < filter.length && /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
              onClick: loadMore,
              className: 'text-center load',
              md: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLoadMore/* default */.Z, {
                icon: true,
                nolink: true,
                color: '#3C3C3B',
                hoverColor: '#3C3C3B',
                text: 'Load More'
              })
            })
          })]
        }), activeTab === 'blog' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-tab": 'blog',
          className: "   blog-slider__slider-wrap ".concat(activeTab === 'blog' ? 'active' : ''),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "blog-slider__slider-wrap__inner row",
            children: (data === null || data === void 0 ? void 0 : (_data$blog = data.blog) === null || _data$blog === void 0 ? void 0 : _data$blog.length) > 0 ? data === null || data === void 0 ? void 0 : (_data$blog2 = data.blog) === null || _data$blog2 === void 0 ? void 0 : _data$blog2.map(function (e, index) {
              var _e$data, _e$data2, _e$data3, _e$images, _e$images$list, _e$images$list$, _e$images2, _e$images2$list, _e$images2$list$, _e$images3, _e$images3$list, _e$images3$list$, _e$data4, _e$data5, _e$data6, _e$data7, _e$data8, _e$data9, _e$category, _e$category$category_, _e$category2, _e$category2$category;

              var dateString = e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.created_at;
              var date = new Date(dateString);
              var options1 = {
                day: 'numeric'
              };
              var options2 = {
                month: 'long',
                year: 'numeric'
              };
              var formattedDate1 = date.toLocaleDateString('en-US', options1);
              var formattedDate2 = date.toLocaleDateString('en-US', options2);
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                md: 4,
                className: 'blog-single-single-wrp',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-single ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "blog-single__inner",
                    children: [(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.slug) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "blog/".concat(e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.slug),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {})
                    }), (e === null || e === void 0 ? void 0 : (_e$images = e.images) === null || _e$images === void 0 ? void 0 : (_e$images$list = _e$images.list) === null || _e$images$list === void 0 ? void 0 : (_e$images$list$ = _e$images$list[0]) === null || _e$images$list$ === void 0 ? void 0 : _e$images$list$.full_path) && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                      alt: 'Shanta Securities Limited',
                      src: e !== null && e !== void 0 && (_e$images2 = e.images) !== null && _e$images2 !== void 0 && (_e$images2$list = _e$images2.list) !== null && _e$images2$list !== void 0 && (_e$images2$list$ = _e$images2$list[0]) !== null && _e$images2$list$ !== void 0 && _e$images2$list$.full_path ? e === null || e === void 0 ? void 0 : (_e$images3 = e.images) === null || _e$images3 === void 0 ? void 0 : (_e$images3$list = _e$images3.list) === null || _e$images3$list === void 0 ? void 0 : (_e$images3$list$ = _e$images3$list[0]) === null || _e$images3$list$ === void 0 ? void 0 : _e$images3$list$.full_path : '/images/static/report.jpg',
                      objectFit: 'cover',
                      layout: 'fill'
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "blog-single__inner__content",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "blog-single__inner__content__top",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "hover-content",
                          children: [(e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.body) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data5 = e.data) === null || _e$data5 === void 0 ? void 0 : _e$data5.subtitle)
                          }), (e === null || e === void 0 ? void 0 : (_e$data6 = e.data) === null || _e$data6 === void 0 ? void 0 : _e$data6.slug) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                            className: 'link-dc',
                            href: "blog/".concat(e === null || e === void 0 ? void 0 : (_e$data7 = e.data) === null || _e$data7 === void 0 ? void 0 : _e$data7.slug),
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {})
                          })]
                        }), (e === null || e === void 0 ? void 0 : (_e$data8 = e.data) === null || _e$data8 === void 0 ? void 0 : _e$data8.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                          children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : (_e$data9 = e.data) === null || _e$data9 === void 0 ? void 0 : _e$data9.title)
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single__inner__content__bottom",
                        children: (e === null || e === void 0 ? void 0 : (_e$category = e.category) === null || _e$category === void 0 ? void 0 : (_e$category$category_ = _e$category.category_data) === null || _e$category$category_ === void 0 ? void 0 : _e$category$category_.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          children: e === null || e === void 0 ? void 0 : (_e$category2 = e.category) === null || _e$category2 === void 0 ? void 0 : (_e$category2$category = _e$category2.category_data) === null || _e$category2$category === void 0 ? void 0 : _e$category2$category.title
                        })
                      })]
                    })]
                  })
                })
              });
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: 'col-md-12 commingsoon',
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                children: "Coming Soon"
              })
            })
          })
        }), activeTab === 'report' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-tab": 'report',
          className: " extramargin  blog-slider__slider-wrap  ".concat(activeTab === 'report' ? 'active' : ''),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "blog-slider__slider-wrap__inner row",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
              md: 12,
              className: 'filter',
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                className: 'desktop',
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'economy' ? 'active' : '',
                  id: "economy",
                  onClick: function onClick() {
                    return handleClickReports('economy', 1);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Economy',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'market' ? 'active' : '',
                  id: "market",
                  onClick: function onClick() {
                    return handleClickReports('market', 2);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Market Review',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'sector' ? 'active' : '',
                  id: "sector",
                  onClick: function onClick() {
                    return handleClickReports('sector', 3);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Strategy Report',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'company' ? 'active' : '',
                  id: "company",
                  onClick: function onClick() {
                    return handleClickReports('company', 4);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Company Updates',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'ipo_notes' ? 'active' : '',
                  id: "ipo_notes",
                  onClick: function onClick() {
                    return handleClickReports('ipo_notes', 7);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'IPO/QIO Notes',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'fixed_income' ? 'active' : '',
                  id: "fixed_income",
                  onClick: function onClick() {
                    return handleClickReports('fixed_income', 8);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Fixed Income Notes',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabReports === 'flash_notes' ? 'active' : '',
                  id: "flash_notes",
                  onClick: function onClick() {
                    return handleClickReports('flash_notes', 9);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Flash Notes',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mobile",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                  ref: selectInputRefSelectReport,
                  isSearchable: false,
                  value: selectMobileValue,
                  placeholder: selectMobilePlaceHolder,
                  onChange: function onChange(e) {
                    handleReport(e === null || e === void 0 ? void 0 : e.value, e === null || e === void 0 ? void 0 : e.id);
                    setSelectMobileValue(e);
                  },
                  styles: {
                    dropdownIndicator: function dropdownIndicator(provided, state) {
                      return _objectSpread(_objectSpread({}, provided), {}, {
                        transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                      });
                    }
                  },
                  classNamePrefix: 'react-select',
                  className: 'form-select',
                  options: DropdownOptionReports,
                  theme: function theme(_theme2) {
                    return _objectSpread(_objectSpread({}, _theme2), {}, {
                      borderRadius: 0,
                      colors: _objectSpread(_objectSpread({}, _theme2.colors), {}, {
                        primary25: '#e9e9e9',
                        primary: 'black'
                      })
                    });
                  }
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
              md: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "date date_wise_filter",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex",
                  children: activeTabReports === 'flash_notes' || activeTabReports === 'ipo_notes' ? null : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "title",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
                        children: "Filter by Topic"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "filter custom_filter",
                      children: filterCustom && /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                        ref: selectInputRefSelect,
                        placeholder: selectedFilter ? selectedFilter : 'Select Topic',
                        onChange: function onChange(e) {
                          return handleFilter(e, activeTabReports ? activeTabReports : '');
                        },
                        styles: {
                          dropdownIndicator: function dropdownIndicator(provided, state) {
                            return _objectSpread(_objectSpread({}, provided), {}, {
                              transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                            });
                          }
                        },
                        isSearchable: false,
                        classNamePrefix: 'react-select',
                        className: 'form-select',
                        options: filterCustom,
                        theme: function theme(_theme3) {
                          return _objectSpread(_objectSpread({}, _theme3), {}, {
                            borderRadius: 0,
                            colors: _objectSpread(_objectSpread({}, _theme3.colors), {}, {
                              primary25: '#e9e9e9',
                              primary: 'black'
                            })
                          });
                        }
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "title",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
                      children: "Filter by Date"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
                    onSubmit: "",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "rs-container",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DateRangePicker/* default */.Z, {
                        editable: false,
                        ref: dateRangePickerRef,
                        cleanable: false,
                        onChange: handleSelect,
                        onFocus: handleFocus,
                        showMeridian: true,
                        onBlur: handleBlur,
                        character: ' to ',
                        placement: 'auto',
                        value: dateRange,
                        preventOverflow: true,
                        placeholder: 'Start Date to End Date'
                      })
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "min-height-box",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'economy',
                className: "  blog-slider__slider-wrap ".concat(activeTabReports === 'economy' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter2 = filter) === null || _filter2 === void 0 ? void 0 : _filter2.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "Economy"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'market',
                className: "  blog-slider__slider-wrap ".concat(activeTabReports === 'market' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter3 = filter) === null || _filter3 === void 0 ? void 0 : _filter3.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "Market Review"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'sector',
                className: "  blog-slider__slider-wrap ".concat(activeTabReports === 'sector' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter4 = filter) === null || _filter4 === void 0 ? void 0 : _filter4.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "Strategy Report"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'company',
                className: "  blog-slider__slider-wrap ".concat(activeTabReports === 'company' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter5 = filter) === null || _filter5 === void 0 ? void 0 : _filter5.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "Company Updates"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'ipo_notes',
                className: "  blog-slider__slider-wrap ".concat(activeTabReports === 'ipo_notes' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter6 = filter) === null || _filter6 === void 0 ? void 0 : _filter6.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "IPO/QIO Notes"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'fixed_income',
                className: "blog-slider__slider-wrap ".concat(activeTabReports === 'fixed_income' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter7 = filter) === null || _filter7 === void 0 ? void 0 : _filter7.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.subtitle)
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "Fixed Income Notes"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'flash_notes',
                className: "blog-slider__slider-wrap ".concat(activeTabReports === 'flash_notes' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "blog-slider__slider-wrap__inner row",
                  children: filter && ((_filter8 = filter) === null || _filter8 === void 0 ? void 0 : _filter8.map(function (e, index) {
                    var dateString = e === null || e === void 0 ? void 0 : e.date;
                    var date = new Date(dateString);
                    var options1 = {
                      day: 'numeric'
                    };
                    var options2 = {
                      month: 'long',
                      year: 'numeric'
                    };
                    var formattedDate1 = date.toLocaleDateString('en-US', options1);
                    var formattedDate2 = date.toLocaleDateString('en-US', options2);
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                      md: 4,
                      className: 'blog-single-single-wrp',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "blog-single ",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "blog-single__inner",
                          children: [(e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                            href: e === null || e === void 0 ? void 0 : e.attachment,
                            target: '_blank'
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* Img */.E, {
                            alt: 'Shanta Securities Limited',
                            src: '/images/static/report.jpg',
                            objectFit: 'cover',
                            layout: 'fill'
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                            className: "blog-single__inner__content",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__top",
                              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                className: "hover-content",
                                children: [(e === null || e === void 0 ? void 0 : e.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                  children: e === null || e === void 0 ? void 0 : e.subtireactHtmlParsertle
                                }), (e === null || e === void 0 ? void 0 : e.attachment) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                                  className: 'link-dc',
                                  href: e === null || e === void 0 ? void 0 : e.attachment,
                                  target: '_blank',
                                  children: "Read More"
                                })]
                              }), (e === null || e === void 0 ? void 0 : e.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                                children: (0,lib/* default */.ZP)(e === null || e === void 0 ? void 0 : e.title)
                              })]
                            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                              className: "blog-single__inner__content__bottom",
                              children: [dateString && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                                children: formattedDate1
                              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                                children: [dateString && (0,lib/* default */.ZP)(formattedDate2), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                  children: "Flash Notes"
                                })]
                              })]
                            })]
                          })]
                        })
                      })
                    }, index);
                  }))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "no_data ".concat(((_filter9 = filter) === null || _filter9 === void 0 ? void 0 : _filter9.length) === 0 || ((_filter10 = filter) === null || _filter10 === void 0 ? void 0 : _filter10.length) === undefined ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: "No Data Found"
                })
              })]
            })]
          })
        }), activeTab === 'dashboard' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-tab": 'dashboard',
          className: " extramargin  blog-slider__slider-wrap ".concat(activeTab === 'dashboard' ? 'active' : ''),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "blog-slider__slider-wrap__inner row",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
              md: 12,
              className: 'filter',
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                className: 'desktop',
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabDashboard === 'economic_dashboard' ? 'active' : '',
                  id: "economic_dashboard",
                  onClick: function onClick() {
                    return handleClickDashboard('economic_dashboard');
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Economic Dashboard',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabDashboard === 'company_dashboard' ? 'active' : '',
                  id: "company_dashboard",
                  onClick: function onClick() {
                    return handleClickDashboard('company_dashboard');
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Company Dashboard',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: activeTabDashboard === 'interest_rate' ? 'active' : '',
                  id: "interest_rate",
                  onClick: function onClick() {
                    return handleClickDashboard('interest_rate');
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    border: '1px',
                    borderColor: 'rgba(60,60,59,0.5)',
                    width: '100',
                    text: 'Interest Rate',
                    color: '#3C3C3B',
                    hoverBackground: globalStyleVars/* hover */.Mr,
                    background: 'transparent'
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mobile",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                  placeholder: 'Select Dashboard',
                  onChange: function onChange(e) {
                    return handleDashboard(e.value);
                  },
                  styles: {
                    dropdownIndicator: function dropdownIndicator(provided, state) {
                      return _objectSpread(_objectSpread({}, provided), {}, {
                        transform: state.selectProps.menuIsOpen && "rotate(180deg)"
                      });
                    }
                  },
                  classNamePrefix: 'react-select',
                  className: 'form-select',
                  options: DropdownOptionDasboard,
                  theme: function theme(_theme4) {
                    return _objectSpread(_objectSpread({}, _theme4), {}, {
                      borderRadius: 0,
                      colors: _objectSpread(_objectSpread({}, _theme4.colors), {}, {
                        primary25: '#e9e9e9',
                        primary: 'black'
                      })
                    });
                  }
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "min-height-box",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'economic_dashboard',
                className: "  blog-slider__slider-wrap ".concat(activeTabDashboard === 'economic_dashboard' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  md: 12,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "iframe-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                      title: "ecomomy dashboard",
                      width: "1100",
                      height: "720",
                      src: "https://app.powerbi.com/view?r=eyJrIjoiOTJiYTMxMWQtZTA3NS00ZTc5LThhNjctYzU2MWM0YzVhMGUxIiwidCI6ImE3MTQzNzA2LTkwZjEtNDM3NS1iZjdhLTU2NWRkZTMxOTgxZCIsImMiOjEwfQ%3D%3D",
                      frameBorder: "0",
                      allowFullScreen: "true"
                    })
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'company_dashboard',
                className: "blog-slider__slider-wrap ".concat(activeTabDashboard === 'company_dashboard' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  md: 12,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "iframe-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                      title: "Company Dashboard",
                      width: "1024",
                      height: "1060",
                      src: "https://app.powerbi.com/view?r=eyJrIjoiOTliOTk3YjMtMDlmZi00MmJhLWI1NjgtNjFmZDIwMzY3MTkyIiwidCI6ImE3MTQzNzA2LTkwZjEtNDM3NS1iZjdhLTU2NWRkZTMxOTgxZCIsImMiOjEwfQ%3D%3D",
                      frameBorder: "0",
                      allowFullScreen: "true"
                    })
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                "data-tab": 'interest_rate',
                className: "blog-slider__slider-wrap ".concat(activeTabDashboard === 'interest_rate' ? 'active' : ''),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  md: 12,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "iframe-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                      title: "interest rates",
                      width: "1024",
                      height: "612",
                      src: "https://app.powerbi.com/view?r=eyJrIjoiZWI1NmE0YjgtZWU5Ny00MzUyLWI3YTQtNjM1ZTBlNzhjMjZmIiwidCI6ImE3MTQzNzA2LTkwZjEtNDM3NS1iZjdhLTU2NWRkZTMxOTgxZCIsImMiOjEwfQ%3D%3D",
                      frameBorder: "0",
                      allowFullScreen: "true"
                    })
                  })
                })
              })]
            })]
          })
        }), activeTab === 'expert' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          "data-tab": 'expert',
          className: "  blog-slider__slider-wrap ".concat(activeTab === 'expert' ? 'active' : ''),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExpertList, {
            data: data === null || data === void 0 ? void 0 : data.expert
          })
        })]
      })]
    })
  });
};

var ResearchList_StyledBlog = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ResearchList__StyledBlog",
  componentId: "sc-58x6jj-0"
})(["padding-top:80px;.iframe-container{position:relative;width:100%;padding-bottom:56.25%;height:0;@media(max-width:767px){padding-bottom:130%;}}.iframe-container iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:0;html{width:100%;}}.min-height-box{min-height:60vh;width:100%;.blog-slider__slider-wrap{}}.css-lkh0o5-menu{z-index:9;margin:0;}.mobile{display:none;}.filter{margin-bottom:30px;ul{display:flex;gap:30px;flex-wrap:wrap;justify-content:center;}.active{a{&:before{transform:unset;}span{color:white;}}}}.extramargin{padding:0 15px;}.blog-title{position:relative;p{position:absolute;top:0;right:0;}}.hover-content{h6{color:white;font-size:20px;line-height:24px;}}.blog-slider__slider-wrap{visibility:hidden;height:0;opacity:0;display:none;.blog-single-single-wrp{opacity:0;transition:3s all ease;transition-delay:1s;}.commingsoon{opacity:0;transition:1s opacity ease,0.5s height ease,0.5s visibility ease;display:none;}&.active{visibility:visible;height:auto;display:block;opacity:1;.commingsoon{opacity:1;transition:1s all ease;display:block;}.blog-single-single-wrp{opacity:1;transition-delay:1s;}}&.blog-tab{.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single__inner{padding-top:calc(460 / 370 * 100%);position:relative;a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{&:after{display:none !important;height:100%;width:100%;top:0;left:0;right:0;position:absolute;transition:height 1s cubic-bezier(.25,.74,.22,.99);}&__top{.hover-content{position:absolute;left:40px;top:40px;right:40px;transition:all 1s cubic-bezier(.25,.74,.22,.99);transform:translateY(-30px);opacity:0;.link-dc{font-size:16px;line-height:24px;color:#FFFFFF;font-family:'Avenir Heavy';width:auto !important;height:auto !important;position:relative !important;margin-top:5px;opacity:0;display:inline-block;&:before{background:#fff;transition:all 1s cubic-bezier(.25,.74,.22,.99) 0s;content:\"\";position:absolute;left:0px;bottom:0px;height:1px;width:100%;}&:hover{&:before{height:4px;}}}p{font-size:16px;font-weight:500;line-height:24px;color:#ffffff;z-index:2;margin:0;opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:20px;font-weight:500;font-family:", ";line-height:28px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;padding-top:20px;z-index:2;h4{font-size:16px;color:#FFFFFF;font-family:'Avenir';font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:16px;color:#FFFFFF;text-align:right;font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:#FFFFFF;}}}}&:hover{.blog-single__inner__content:after{height:0;}.blog-single__inner__content__top{h2{}.link-dc{transform:none;opacity:1;&:before{}}.hover-content{transform:none;opacity:1;}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}}}.blog-single-single-wrp{margin-bottom:30px;}.load{.dc-btn{display:flex;align-items:center;justify-content:center;margin-top:50px;}}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{padding-top:115%;}}}}}.blog-single__inner{padding-top:calc(460 / 370 * 100%);position:relative;a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{&:after{content:'';height:100%;width:100%;background-color:#3C3C3B;top:0;left:0;right:0;position:absolute;transition:height 1s cubic-bezier(.25,.74,.22,.99);}&__top{.hover-content{position:absolute;left:40px;top:40px;right:40px;transition:all 1s cubic-bezier(.25,.74,.22,.99);transform:translateY(-30px);opacity:0;.link-dc{font-size:16px;line-height:24px;color:#FFFFFF;font-family:'Avenir Heavy';width:auto !important;height:auto !important;position:relative !important;margin-top:5px;opacity:0;display:inline-block;&:before{background:#fff;transition:all 1s cubic-bezier(.25,.74,.22,.99) 0s;content:\"\";position:absolute;left:0px;bottom:0px;height:1px;width:100%;}&:hover{&:before{height:4px;}}}p{font-size:16px;font-weight:500;line-height:24px;color:#ffffff;z-index:2;margin:0;opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:20px;font-weight:500;font-family:", ";line-height:28px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;padding-top:20px;z-index:2;h4{font-size:60px;color:#FFFFFF;font-family:'Avenir Book';line-height:60px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:16px;color:#FFFFFF;text-align:right;font-weight:500;line-height:24px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:#FFFFFF;}}}}&:hover{.blog-single__inner__content:after{height:0;}.blog-single__inner__content__top{h2{opacity:0;transform:translateY(-20px);}.link-dc{transform:none;opacity:1;&:before{}}.hover-content{transform:none;opacity:1;}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}@media (max-width:767px){.mobile{display:block;}.desktop{display:none !important;}padding-top:0;.filter{padding:0;.react-select__control{border:none !important;height:60px;background:#978c21;box-shadow:none !important;border-radius:0 !important;.react-select__control--menu-is-open{box-shadow:none !important;.react-select__indicator{padding-right:15px;}}.react-select__value-container{padding:0px 15px;}.react-select__indicator{padding:15px;svg{path{fill:white;stroke-width:0;}}}.react-select__indicator-separator{display:none;}.react-select__single-value{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}.select__single-value,.react-select__placeholder{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}.react-select__input-container{.react-select__input{font-family:'Avenir' !important;font-size:16px !important;font-weight:500 !important;line-height:24px !important;color:#FFFFFF !important;}}}}.blog-single__inner__content__top{p,h2{left:30px;right:30px;top:30px;}}.blog-single__inner__content__bottom h4,.blog-single__inner__content__bottom p{left:30px;right:30px;top:30px;}.swiper-initialized{margin-left:0;padding-right:0;}.blog-slider{&__slider-wrap{.slider-nav-mobile{margin-top:40px;ul{display:flex;}li{height:50px;width:50px;background-color:#000;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}}.blog-button{margin-bottom:40px;.slider-nav{display:none;}}.slider-nav-mobile{display:block;}}.filter_new_design{ul{gap:0;flex-wrap:unset;li{width:100%;&.active{span{color:#978C21;}a{&:before{transform:unset;opacity:1;}}}}}.dc-btn{a{border-radius:0;border-left:none !important;border-right:none !important;border-top:none !important;border-bottom:none !important;padding:0px 20px;span{line-height:20px;}&:before{height:2px !important;border-radius:0;top:unset;bottom:0;transform:unset;opacity:0;}&:after{content:'';background:rgba(198,198,198,0.5);height:1px;width:100%;position:absolute;left:0;right:0;bottom:0;}&:hover{span{color:#978C21;}&:before{transform:unset;opacity:1;}}}}}.date_wise_filter{display:flex;justify-content:space-between;.flex{display:flex;justify-content:center;gap:30px;margin:0 -15px 80px;.title{h6{font-size:20px;font-weight:300;line-height:46px;}}.rs-picker-toggle-wrapper{display:inline-block;vertical-align:middle;max-width:100%;min-width:250px;border-radius:0px;display:flex;align-items:center;justify-content:center;}.rs-picker-toggle-textbox{padding-left:0px;}.rs-picker-daterange .rs-picker-toggle.rs-btn{outline:none;box-shadow:none;}.rs-picker-daterange .rs-picker-toggle.rs-btn .rs-picker-toggle-clean{top:-10px;}.rs-picker-toggle-textbox,.rs-picker-has-value .rs-btn .rs-picker-toggle-value,.rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{color:black;font-weight:500;line-height:45px;}hDFtcC .date_wise_filter .flex .rs-picker-toggle-textbox{padding-left:0px;font-weight:500;color:black;line-height:45px;}.rs-calendar-table-cell-selected .rs-calendar-table-cell-content{background-color:#978C21;}.rs-picker-toggle-clean:hover svg path{stroke:#978C21;}.rs-picker-default .rs-picker-toggle.rs-btn{padding:0 0 0 15px;height:45px;box-sizing:border-box;border:1px solid rgba(60,60,59,0.5);border-radius:22px;display:flex;justify-content:space-between;width:100%;.rs-stack{width:100%;}}.rs-picker-daterange .rs-picker-toggle.rs-btn .rs-picker-toggle-caret{top:-10px;}}.rs-picker-default .rs-picker-toggle.rs-btn .rs-stack{top:1px;}.rs-picker-toggle .rs-picker-toggle-placeholder,.rs-picker-toggle-textbox{font-size:16px;font-weight:500;line-height:45px !important;color:rgb(60,60,59) !important;}}.no_data{opacity:0;visibility:hidden;height:0;}.no_data.active{opacity:1;transition:1s all ease;transition-delay:0.5s;height:auto;visibility:visible;}[data-tab=\"dashboard\"],[data-tab=\"expert\"],[data-tab=\"blog\"],[data-tab=\"news_flash\"]{margin-top:50px;}@media (max-width:767px){.date_wise_filter .flex{flex-direction:column;}}.react-select__control{padding:0px 0px 0px 15px;height:45px;box-sizing:border-box;border:1px solid rgba(60,60,59,0.5);border-radius:22px;display:flex;-webkit-box-pack:justify;width:100%;min-width:330px;align-items:center;justify-content:center;}.css-1jqq78o-placeholder{color:rgb(60,60,59);margin-left:0;margin-right:0;box-sizing:border-box;line-height:41px;}@media (max-width:992px){.date_wise_filter{display:flex;flex-direction:column;align-items:flex-start;margin-bottom:0;display:block;width:100%;.flex{margin-bottom:0;display:block;&:last-child{margin-bottom:60px;}}}.custom_filter{.filter .react-select__control{padding:0px 0px 0px 15px !important;height:45px !important;box-sizing:border-box !important;border:1px solid rgba(60,60,59,0.5) !important;border-radius:22px !important;display:flex !important;-webkit-box-pack:justify !important;width:100% !important;min-width:330px;align-items:center;justify-content:center;background:transparent !important;}.css-1jqq78o-placeholder{color:rgb(60,60,59) !important;margin-left:0 !important;margin-right:0 !important;box-sizing:border-box !important;line-height:41px;}}}.rs-input-group{border:1px solid rgba(60,60,59,0.5);height:45px;box-sizing:border-box;border-radius:30px;}.rs-input-group.rs-input-group-inside .rs-input{border-radius:30px;}@media(max-width:767px){.rs-picker-daterange-calendar-group{height:auto;min-width:unset;display:flex;flex-direction:column;width:100%;}}"], Title["default"], Title["default"]);
/* harmony default export */ var ResearchList = (ResearchList_RandomSliderV1);

/***/ })

}]);